import { useContext } from 'react'
import {
  QuickSelectionLabelContainer,
  QuickSelectText
} from '../../../styled-components'
import {
  ChevronDownSmall,
  ChevronUpSmall
} from '../../../../../atoms/icons/essentials/index.js'
import colorsOptions from '../../../../../fundamentals/colors-styles/constants.js'
import { iconSizeOptions } from '../../../../../atoms/icons/icons-sizes.js'
import { QuickSelectContext } from './quick-select-context.jsx'

const QuickSelectLabel = ({
  label,
  disabled = false,
  containerWidth,
  ...props
}) => {
  const { isOpen, setIsOpen } = useContext(QuickSelectContext)

  const handleClick = () => {
    if (!disabled) {
      props.onClick?.(!isOpen)

      setIsOpen(!isOpen)
    }
  }

  return (
    <QuickSelectionLabelContainer onClick={handleClick} disabled={disabled}>
      <QuickSelectText>{label}</QuickSelectText>
      {isOpen ? (
        <ChevronUpSmall
          stroke={colorsOptions.greys.white}
          size={iconSizeOptions['ICON-XXS']}
          strokeWidth={8}
        />
      ) : (
        <ChevronDownSmall
          stroke={colorsOptions.greys.white}
          size={iconSizeOptions['ICON-XXS']}
          strokeWidth={8}
        />
      )}
    </QuickSelectionLabelContainer>
  )
}

export default QuickSelectLabel
